const initualState = {
  visible: false,
  data: {},
  onOptionSelect: null,
};

export default (state = initualState, action) => {
  console.log("action.payload =>", action.payload);

  switch (action.type) {
    case "SET_ACTIVATION_MODAL":
      return { ...state, ...action.payload };

    case "REMOVE_ACTIVATION_MODAL":
      return { ...state, visible: false };

    case "CLEAR_ACTIVATION_MODAL":
      return { ...state, visible: false };
    default:
      return state;
  }
};
